import React from "react";

import { useDevices } from "./useDevices";

type ContextValue = {
  videoDevices: MediaDeviceInfo[];
  audioDevices: MediaDeviceInfo[];
  videoTrack: MediaStreamTrack | undefined;
  audioTrack: MediaStreamTrack | undefined;
  selectedVideoDeviceId: string;
  selectedAudioDeviceId: string;
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
  devicesStatus: "IDLE" | "LOADING" | "READY" | "ERROR";
  initializeDevices: () => void;
  cleanupDevices: () => void;
  handleVideoChange: (deviceId: string) => void;
  handleAudioChange: (deviceId: string) => void;
  toggleVideo: () => void;
  toggleAudio: () => void;
};

export const DevicesContext = React.createContext<ContextValue>({} as ContextValue);

export const useDevicesContext = () => {
  const context = React.useContext(DevicesContext);
  if (!context) {
    throw new Error("useDevicesContext must be used within a DevicesProvider");
  }
  return context;
};

export type DevicesProviderProps = {
  children: React.ReactNode;
};

export const DevicesProvider: React.FC<DevicesProviderProps> = props => {
  const devicesState = useDevices();
  return <DevicesContext.Provider value={devicesState}>{props.children}</DevicesContext.Provider>;
};
